import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const TikTokPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to TikTok Shopping Ads"
      description="Step-by-step instructions for adding your Upfeed product feed to TikTok Ads Manager to run Shopping and Dynamic Product Ads."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to TikTok Shopping Ads</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to TikTok
            Ads Manager so you can run Shopping and Dynamic Product Ads.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>A TikTok for Business account with Ads Manager access.</li>
            </ul>
          </div>

          <h2>Setting up your TikTok product catalog</h2>
          <ul>
            <li>
              Log in to{" "}
              <a href="https://ads.tiktok.com" target="_blank" rel="noreferrer">
                TikTok Ads Manager
              </a>{" "}
              and navigate to Assets &gt; Catalog.
            </li>
            <li>
              Click 'Create Catalog' and choose 'E-commerce' as the catalog
              type.
            </li>
            <li>
              Under 'How would you like to add products?', select 'URL Upload'.
            </li>
            <li>
              Paste your product feed URL from the app and select 'CSV' as the
              file type.
            </li>
            <li>Set the refresh schedule to 'Daily' and click 'Confirm'.</li>
            <li>
              Wait for TikTok to process your feed — this can take a few hours
              on the first upload.
            </li>
          </ul>

          <h2>Running Shopping Ads</h2>
          <p>
            Once your catalog is approved, create a new campaign in TikTok Ads
            Manager and choose 'Product Sales' as the objective. Select your
            catalog, configure your ad group targeting and budget, and launch
            your Shopping or Dynamic Product Ads.
          </p>

          <RelatedPlatforms currentSlug="tiktok" />
        </div>
      </div>
    </div>
  </Layout>
)

export default TikTokPage
